import { GET_NDHM_HOST } from "../../constants/env";
import fetch from "../../fetch-client";
import { AxonGenericApiResponse } from "../../types/axon";

export default async function isHprIdAvailable({
  hprUsername,
}: {
  hprUsername: string;
}): Promise<AxonGenericApiResponse<{ available: boolean }>> {
  try {
    const NDHM_HOST = GET_NDHM_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const body = JSON.stringify({
      hprId: hprUsername,
    });

    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body,
      mode: "cors",
      credentials: "include",
    };
    const response = await fetch(
      `${NDHM_HOST}/abdm/nhpr/v1/hpr/aadhaar/check/available`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
